import React from "react";
import Sidebar from "./modules/Sidebar";
import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function App() {
  // 未認証時、Auth0画面へ
  const RedirectToLogin = () => {
    const { loginWithRedirect } = useAuth0();
    loginWithRedirect();
    return <></>;
  };
  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <>
      {isLoading ? (
        // ログイン試行中はローディング画面を表示
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "#f2f2f2",
            }}
          >
            <CircularProgress />
          </Box>
        </>
      ) : isAuthenticated ? (
        // 認証済み時はログイン後の画面を表示
        <>
          <Sidebar />
        </>
      ) : (
        // 未認証時はAuth0のログイン画面にリダイレクト
        <>
          <RedirectToLogin />
        </>
      )}
    </>
  );
}
